export default function getChipRaiseAmount(action) {
	return parseFloat(action) - 11;
}
